(function () {
  const slide = document.getElementById('es-slide')
  if (!slide) return
  const KEY = 'pjs-es-dismissed'
  const days = Number(slide.dataset.rememberDays || 30)
  try {
    const until = parseInt(localStorage.getItem(KEY) || '0', 10)
    if (until && Date.now() < until) return
  } catch (e) {}
  if (document.querySelector('.es-form .es-ok')) return

  function menuOpen () {
    return !!document.querySelector('.lo-nav-item.is-open')
  }

  function consentOpen () {
    const b = document.querySelector('.shopify-pc__banner, [id^="shopify-pc__banner"]')
    if (!b) return false
    const box = b.getBoundingClientRect()
    return box.width > 0 && box.height > 0 && getComputedStyle(b).visibility !== 'hidden'
  }

  let shown = false
  function open () {
    if (shown) return
    if (consentOpen() || menuOpen()) {
      setTimeout(open, 900)
      return
    }
    shown = true
    slide.hidden = false
    void slide.offsetHeight
    slide.classList.add('is-on')
    window.removeEventListener('scroll', onScroll)
  }
  function dismiss () {
    slide.classList.remove('is-on')
    setTimeout(function () {
      slide.hidden = true
    }, 260)
    try {
      localStorage.setItem(KEY, String(Date.now() + days * 864e5))
    } catch (e) {}
  }
  function onScroll () {
    const maxScroll = document.body.scrollHeight - window.innerHeight
    if (
      maxScroll > 0 &&
      (window.scrollY / maxScroll) * 100 >= Number(slide.dataset.scrollPercent || 45)
    ) { open() }
  }
  slide.querySelector('[data-es-close]').addEventListener('click', dismiss)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && slide.classList.contains('is-on')) dismiss()
  })
  slide.addEventListener('submit', function () {
    try {
      localStorage.setItem(KEY, String(Date.now() + 365 * 864e5))
    } catch (e) {}
  })

  window.addEventListener('scroll', onScroll, { passive: true })
  setTimeout(open, Number(slide.dataset.delaySeconds || 20) * 1000)
})()
